import { FunctionComponent, JSX, SyntheticEvent, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import { GET_ACCOUNT_CITIES_MATCH } from '@/modules/API/account/accountHandler'
import { AutocompleteRenderInputParams } from '@mui/material'
import styles from './citySelect.module.scss'

interface CountrySelectProps {
    city: string
    setCity: (city: string) => void
    country: string
    parent?: boolean
}

const CitySelect: FunctionComponent<CountrySelectProps> = ({ city, setCity, country, parent }) => {
    const { t } = useTranslation()

    const [inputValue, setInputValue] = useState(city)
    const [cityOptions, setCityOptions] = useState<string[]>([])

    const [getAccountCitiesMatch, { data: dataCitiesMatch }] = useLazyQuery(GET_ACCOUNT_CITIES_MATCH)

    useEffect(() => {
        if (dataCitiesMatch?.getAccountCitiesMatch) {
            setCityOptions(dataCitiesMatch.getAccountCitiesMatch)
        }
    }, [dataCitiesMatch])

    useEffect(() => {
        if (inputValue && country) {
            getAccountCitiesMatch({ variables: { city: inputValue, country } })
        }
    }, [inputValue, country])

    function normalizeString(s: string): string {
        return s
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[-'’\s]/g, '')
            .toLowerCase()
    }

    function filterOptions(options: string[], { inputValue }: { inputValue: string }): string[] {
        const q: string = normalizeString(inputValue || '')
        if (!q) return options.slice(0, 5)
        return options.filter((opt) => normalizeString(opt).includes(q)).slice(0, 5)
    }

    return (
        <Autocomplete
            options={cityOptions}
            autoHighlight
            getOptionLabel={(option: string): string => option}
            renderOption={(props, option: string): JSX.Element => (
                <Box component='li' {...props}>
                    {option}
                </Box>
            )}
            renderInput={(params: AutocompleteRenderInputParams): JSX.Element => (
                <TextField {...params} variant='outlined' label={t('city')} />
            )}
            className={`${parent ? styles.AutocompleteParent : styles.AutocompleteDaycare} ${styles.Autocomplete}`}
            value={city}
            onChange={(_event: SyntheticEvent, newValue: string | null): void => {
                setCity(newValue || '')
            }}
            inputValue={inputValue}
            onInputChange={(_event: SyntheticEvent, newInputValue: string): void => {
                setInputValue(newInputValue)
            }}
            filterOptions={filterOptions}
        />
    )
}

export default CitySelect
